import React from 'react';
import { DialogTitle, Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';

/**
 * DialogHeader Component
 * Header for the execution history dialog
 */
const DialogHeader = ({ onClose }) => {
  return (
    <DialogTitle>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Execution History</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
  );
};

DialogHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default DialogHeader;
